// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-preview-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 0 40px rgba(225, 6, 19, 0.15), 0 16px 48px rgba(0, 0, 0, 0.5);
  cursor: pointer;
}

.map-preview-container {
  width: 100%;
  height: 100%;
}

.map-preview-overlay {
  position: absolute;
  inset: 0;
  z-index: 20;
  cursor: pointer;
  background: transparent;
}

.map-preview-wrapper .alert-cta-card {
  z-index: 30;
  pointer-events: none;
}

.map-preview-wrapper .signup-submit-btn {
  pointer-events: auto;
}

@media (max-width: 768px) {
  .risk-map-preview {
    border-radius: 12px;
  }

  .risk-map-preview-bar {
    padding: 8px 12px;
  }

  .risk-map-preview-title {
    font-size: 14px;
  }

  .risk-map-preview-legend {
    flex-wrap: wrap;
    gap: 12px;
    padding: 8px 12px;
    justify-content: center;
  }

  .legend-item {
    font-size: 13px;
  }

  .map-preview-wrapper .mapboxgl-ctrl-geocoder {
    width: 100% !important;
    max-width: 200px !important;
    min-width: 140px !important;
    font-size: 13px;
  }

  .map-preview-wrapper .mapboxgl-ctrl-geocoder--input {
    font-size: 13px !important;
    padding: 6px 30px 6px 10px !important;
    height: 34px !important;
  }

  .map-preview-wrapper .mapboxgl-ctrl-geocoder--icon-search {
    width: 16px !important;
    height: 16px !important;
    top: 9px !important;
    left: 8px !important;
  }

  .map-preview-wrapper .mapboxgl-ctrl-geocoder--icon-close {
    width: 14px !important;
    height: 14px !important;
    top: 10px !important;
    right: 8px !important;
  }

  .map-preview-wrapper .mapboxgl-ctrl-geocoder--button {
    padding: 4px !important;
  }

  .mapboxgl-ctrl-geocoder--suggestions {
    font-size: 13px !important;
    max-width: calc(100vw - 32px) !important;
    min-width: 200px !important;
  }

  .mapboxgl-ctrl-geocoder--suggestion {
    padding: 8px 12px !important;
    font-size: 13px !important;
  }

  .map-preview-wrapper .mapboxgl-ctrl-top-right {
    display: flex;
    flex-direction: column;
    gap: 6px;
    top: 8px;
    right: 8px;
  }

  .map-preview-wrapper .mapboxgl-ctrl-bottom-right {
    bottom: 8px;
    right: 8px;
    z-index: 1000 !important;  
  }


  .map-preview-wrapper .mapboxgl-ctrl-group {
    margin: 0 !important;
  }

  .map-preview-wrapper .mapboxgl-ctrl button {
    width: 34px !important;
    height: 34px !important;
  }

  .map-preview-wrapper .mapboxgl-ctrl-group:not(:last-child) {
    margin-bottom: 4px !important;
  }
}

@media (max-width: 480px) {
  .risk-map-preview {
    border-radius: 8px;
  }

  .risk-map-preview-bar {
    padding: 6px 10px;
  }

  .risk-map-preview-title {
    font-size: 13px;
  }

  .risk-map-preview-legend {
    gap: 8px;
    padding: 6px 10px;
  }

  .legend-item {
    font-size: 12px;
  }

  .map-preview-wrapper .mapboxgl-ctrl-geocoder {
    max-width: 140px !important;
    min-width: 100px !important;
  }

  .map-preview-wrapper .mapboxgl-ctrl-geocoder--input {
    font-size: 12px !important;
    padding: 4px 26px 4px 8px !important;
    height: 30px !important;
  }

  .map-preview-wrapper .mapboxgl-ctrl-geocoder--icon-search {
    width: 14px !important;
    height: 14px !important;
    top: 8px !important;
    left: 6px !important;
  }

  .map-preview-wrapper .mapboxgl-ctrl-geocoder--icon-close {
    width: 12px !important;
    height: 12px !important;
    top: 9px !important;
    right: 6px !important;
  }

  .mapboxgl-ctrl-geocoder--suggestions {
    font-size: 12px !important;
    min-width: 160px !important;
  }

  .mapboxgl-ctrl-geocoder--suggestion {
    padding: 6px 10px !important;
    font-size: 12px !important;
  }

  .map-preview-wrapper .mapboxgl-ctrl button {
    width: 30px !important;
    height: 30px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/molecules/mapPreview/MapPreview.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,2EAA2E;EAC3E,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,2BAA2B;IAC3B,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,qCAAqC;IACrC,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,wCAAwC;IACxC,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,UAAU;IACV,wBAAwB;EAC1B;;;EAGA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,oCAAoC;IACpC,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":[".map-preview-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  border-radius: 16px;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 0 40px rgba(225, 6, 19, 0.15), 0 16px 48px rgba(0, 0, 0, 0.5);\n  cursor: pointer;\n}\n\n.map-preview-container {\n  width: 100%;\n  height: 100%;\n}\n\n.map-preview-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 20;\n  cursor: pointer;\n  background: transparent;\n}\n\n.map-preview-wrapper .alert-cta-card {\n  z-index: 30;\n  pointer-events: none;\n}\n\n.map-preview-wrapper .signup-submit-btn {\n  pointer-events: auto;\n}\n\n@media (max-width: 768px) {\n  .risk-map-preview {\n    border-radius: 12px;\n  }\n\n  .risk-map-preview-bar {\n    padding: 8px 12px;\n  }\n\n  .risk-map-preview-title {\n    font-size: 14px;\n  }\n\n  .risk-map-preview-legend {\n    flex-wrap: wrap;\n    gap: 12px;\n    padding: 8px 12px;\n    justify-content: center;\n  }\n\n  .legend-item {\n    font-size: 13px;\n  }\n\n  .map-preview-wrapper .mapboxgl-ctrl-geocoder {\n    width: 100% !important;\n    max-width: 200px !important;\n    min-width: 140px !important;\n    font-size: 13px;\n  }\n\n  .map-preview-wrapper .mapboxgl-ctrl-geocoder--input {\n    font-size: 13px !important;\n    padding: 6px 30px 6px 10px !important;\n    height: 34px !important;\n  }\n\n  .map-preview-wrapper .mapboxgl-ctrl-geocoder--icon-search {\n    width: 16px !important;\n    height: 16px !important;\n    top: 9px !important;\n    left: 8px !important;\n  }\n\n  .map-preview-wrapper .mapboxgl-ctrl-geocoder--icon-close {\n    width: 14px !important;\n    height: 14px !important;\n    top: 10px !important;\n    right: 8px !important;\n  }\n\n  .map-preview-wrapper .mapboxgl-ctrl-geocoder--button {\n    padding: 4px !important;\n  }\n\n  .mapboxgl-ctrl-geocoder--suggestions {\n    font-size: 13px !important;\n    max-width: calc(100vw - 32px) !important;\n    min-width: 200px !important;\n  }\n\n  .mapboxgl-ctrl-geocoder--suggestion {\n    padding: 8px 12px !important;\n    font-size: 13px !important;\n  }\n\n  .map-preview-wrapper .mapboxgl-ctrl-top-right {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    top: 8px;\n    right: 8px;\n  }\n\n  .map-preview-wrapper .mapboxgl-ctrl-bottom-right {\n    bottom: 8px;\n    right: 8px;\n    z-index: 1000 !important;  \n  }\n\n\n  .map-preview-wrapper .mapboxgl-ctrl-group {\n    margin: 0 !important;\n  }\n\n  .map-preview-wrapper .mapboxgl-ctrl button {\n    width: 34px !important;\n    height: 34px !important;\n  }\n\n  .map-preview-wrapper .mapboxgl-ctrl-group:not(:last-child) {\n    margin-bottom: 4px !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .risk-map-preview {\n    border-radius: 8px;\n  }\n\n  .risk-map-preview-bar {\n    padding: 6px 10px;\n  }\n\n  .risk-map-preview-title {\n    font-size: 13px;\n  }\n\n  .risk-map-preview-legend {\n    gap: 8px;\n    padding: 6px 10px;\n  }\n\n  .legend-item {\n    font-size: 12px;\n  }\n\n  .map-preview-wrapper .mapboxgl-ctrl-geocoder {\n    max-width: 140px !important;\n    min-width: 100px !important;\n  }\n\n  .map-preview-wrapper .mapboxgl-ctrl-geocoder--input {\n    font-size: 12px !important;\n    padding: 4px 26px 4px 8px !important;\n    height: 30px !important;\n  }\n\n  .map-preview-wrapper .mapboxgl-ctrl-geocoder--icon-search {\n    width: 14px !important;\n    height: 14px !important;\n    top: 8px !important;\n    left: 6px !important;\n  }\n\n  .map-preview-wrapper .mapboxgl-ctrl-geocoder--icon-close {\n    width: 12px !important;\n    height: 12px !important;\n    top: 9px !important;\n    right: 6px !important;\n  }\n\n  .mapboxgl-ctrl-geocoder--suggestions {\n    font-size: 12px !important;\n    min-width: 160px !important;\n  }\n\n  .mapboxgl-ctrl-geocoder--suggestion {\n    padding: 6px 10px !important;\n    font-size: 12px !important;\n  }\n\n  .map-preview-wrapper .mapboxgl-ctrl button {\n    width: 30px !important;\n    height: 30px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
